module.exports = __webpack_public_path__ + "media/images/black_history_month/linkedinbinderbhm-0a5801a142a23acab9ae941b3c98def0.jpg";